import { MDBBtn, MDBModalFooter } from 'mdb-react-ui-kit';
import React, { forwardRef } from 'react'
import { useTranslation } from 'react-i18next';

const DeleteLocation = forwardRef((props, ref) => {
    const {t, i18n} = useTranslation();
   
    function removeThisGroup(e) {
        props.setDeleteLocFlag(true);
        props.onClose();
    }
  return (
    <>
      <div>
                <span className="phrecording">{t("removeRoleLocation")}</span>
            </div>

            <div style={{ display: "none" }}>
                <button ref={ref} onClick={(e) => { e.stopPropagation(); e.preventDefault(); removeThisGroup(e)}}>
                    {t("remove")}</button>
            </div>

            {/* <MDBModalFooter>
                <MDBBtn color="secondary" onClick={(e) => props.onClose(e)}>
                    {t("cancel")}
                </MDBBtn>
                <MDBBtn onClick={(e) => {
                    e.preventDefault();
                    removeThisGroup(e);
                }}>{t("remove")}</MDBBtn>
            </MDBModalFooter> */}
        
    </>
  )
});

export default DeleteLocation
